import { useGlobalContext } from '../GlobalContextProvider';
import { NotificationActionType, NotificationState } from './notificationReducer';
import { useCallback } from 'react';

export const useNotification = () => {
    const { state, dispatch } = useGlobalContext();
    const notification = state.notification;

    const showNotificationWithInfo = useCallback(
        (info: NotificationState) => {
            dispatch({ type: NotificationActionType.SHOW_NOTIFICATION, payload: info });
        },
        [dispatch]
    );

    const removeNotificationWithInfo = useCallback(() => {
        dispatch({ type: NotificationActionType.REMOVE_NOTIFICATION });
    }, [dispatch]);

    return {
        notification,
        showNotificationWithInfo,
        removeNotificationWithInfo
    };
};
